import { Directive } from '@angular/core';

@Directive({
  selector: '[appHeadline]'
})
export class HeadlineDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/ui/headline/headline.directive.ts